import { render } from "./GeneratorDetail.vue?vue&type=template&id=1f3b63d8&scoped=true&ts=true"
import script from "./GeneratorDetail.vue?vue&type=script&lang=ts"
export * from "./GeneratorDetail.vue?vue&type=script&lang=ts"

import "./GeneratorDetail.vue?vue&type=style&index=0&id=1f3b63d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3b63d8"]])

export default __exports__